export default {
  serviceProvider: null,
  vuexModule: "reports",
  queryParams: {
    refresh: false,
  },
  headerColumns: [
    {
      prop: "name_OR_display_name",
      keys: ["name", "display_name"],
      label: "Report Name",
      minWidth: 250,
      searchable: true,
      sortable: true,
      sortBy: "display_name",
    },
  ],
  actionsWidth: 250,
  sortBy: "name_OR_display_name",
  sortOrder: "asc",
  rowsSelected: [],
};
